<!--滚动信息-->
<template>
  <div
    class="overall-top"
    :class="cls"
    v-stat:show="{ action: 'znzt_ui_cuxiaoxinxi_show' }"
    v-if="activitys.length > 0 || promotions.length > 0"
  >
    <div class="overall-top-swiper">
      <div class="overall-top-rolllist swiper-container" id="topScroll_swiper">
        <div class="overall-top-rollbox swiper-wrapper">
          <div
            class="swiper-slide overall-top-list"
            v-for="item in activitys"
            :key="item.id"
          >
            <a
              v-stat:click="{ action: 'znzt_ui_cuxiaoxinxi_click' }"
              class="overall-top-sale"
              href="javascript:void(0);"
            >
              <div class="overall-top-marquue">
                <span class="overall-top-tag"></span>
                <p click-type="text" data-type="activity">
                  {{ item.title }}
                </p>
              </div>
            </a>
            <a
              click-type="btn"
              data-type="activity"
              class="overall-top-btn"
              href="javascript:void(0);"
              v-stat:click="{ action: 'znzt_dinglancuxiao_baoming_click' }"
              >去报名</a
            >
          </div>
          <div
            class="swiper-slide overall-top-list"
            v-for="item in promotions"
            :key="item.newsid"
          >
            <a class="overall-top-sale" href="javascript:void(0);">
              <div class="overall-top-marquue">
                <span class="overall-top-tag"></span>
                <p
                  click-type="text"
                  data-type="promotion"
                  v-stat:click="{ action: 'znzt_ui_cuxiaoxinxi_click' }"
                >
                  {{ item.title }}
                </p>
              </div>
            </a>
            <a
              class="overall-top-btn"
              href="javascript:void(0);"
              v-stat:click="{ action: 'znzt_dinglancuxiao_baoming_click' }"
              click-type="btn"
              data-type="promotion"
              >去报名</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import layManager from '@/services/layer.manager';
import * as queryValue from '@/services/query.const';
import { Logger } from '@/services/logger';
export default {
  computed: {
    cls () {
      return this.activitys.length > 0 || this.promotions.length > 0 ? '' : 'fn-hide';
    },
    ...mapGetters({
      baseInfo: 'baseInfo',
      activitys: 'activitys',
      promotions: 'promotions'
    }),
    dealerId () {
      return this.baseInfo.dealerId;
    }
  },
  mounted () {
    if (this.$queryParams.from === queryValue.QUERY_FROM_GDXIAOCHENGXU) {
      this.$store.commit('setActivitysAndPromotions', { promotions: [], activitys: [] });
    } else {
      this.createSwiper();
    }
  },
  methods: {
    ...mapActions('news', {
      loadActivityInfo: 'loadActivityInfo',
      loadPromotionInfo: 'loadPromotionInfo'
    }),
    createSwiper () {
      let self = this;
      // swiper 点击事件的坑
      // https://segmentfault.com/a/1190000015327048
      // http://caibaojian.com/swiper-api/methods/on.html
      const container = document.getElementById('topScroll_swiper');
      if (container) {
        this.swiper = new window.Swiper('#topScroll_swiper', {
          loop: true,
          autoplay: 3000,
          autoplayDisableOnInteraction: false,
          direction: 'vertical',
          spaceBetween: 0,
          preventClicksPropagation: false,
          observer: true, // 修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, // 修改swiper的父元素时，自动初始化swiper
          preventLinksPropagation: true
        });
        let actLen = self.activitys.length;
        container
          .addEventListener('click', function (e) {
            if (e.target && self.swiper) {
              let dataType = e.target.getAttribute('data-type');
              let clickType = e.target.getAttribute('click-type');
              let realIndex = self.swiper.realIndex;
              console.log({ dataType, clickType });
              if (dataType && clickType) {
                let item = null;
                if (dataType === 'promotion') {
                  item = self.promotions[realIndex - actLen];
                } else {
                  item = self.activitys[realIndex];
                }
                if (!item) {
                  const logger = new Logger('RollText');
                  logger.warn('用户点击swiper索引为' + realIndex);
                }
                if (clickType === 'btn') {
                  self.signClick(dataType, item);
                } else {
                  self.textClick(dataType, item);
                }
              }
            }
          });
      }
    },
    textClick: function (type, item) {
      let newsid = 0;
      let activityId = 0;
      if (item) {
        newsid = item.newsId || 0;
        activityId = item.id || 0;
      }
      if (type === 'promotion') {
        layManager.loadPromotionInfo(newsid, true);
      } else if (type === 'activity') {
        layManager.loadActivityInfo(activityId);
      }
    },
    signClick: function (type, item) {
      let newsid = 0;
      let activityId = 0;
      if (item) {
        newsid = item.newsId || 0;
        activityId = item.id || 0;
      }
      if (type === 'promotion') {
        this.openPromotionOrder(newsid, false);
      } else if (type === 'activity') {
        layManager.price(0, 0, 'znzt_dinglancuxiao_baoming_click', 2, activityId);
      }
    },
    openPromotionOrder: function (newsId) {
      this.loadPromotionInfo({ id: newsId, openDetail: false }).then(function (res) {
        var seriesId = 0;
        var specid = 0;
        if (res.Specs && res.Specs.length > 0) {
          seriesId = res.Specs[0].SeriesId || 0;
          specid = res.Specs[0].SpecId || 0;
        }
        layManager.price(seriesId, specid, 'znzt_dinglancuxiao_baoming_click', 3);
      }).catch(function (ex) {
        console.error(ex);
        layManager.price(0, 0, 'znzt_dinglancuxiao_baoming_click', 3);
      });
    }
  }
};
</script>

<style lang="scss">
.overall-top {
  position: fixed;
  top: ptrd(100px);
  left: ptrd(20px);
  width: ptrd(500px);
  padding: 0 ptrd(10px);
  box-sizing: border-box;
  height: ptrd(54);
  background: rgba($color: #000000, $alpha: 0.4);
  border-radius: ptrd(54);
  z-index: 1;
  &-rolllist {
    width: 100%;
    height: ptrd(54);
    position: relative;
    overflow: hidden;
  }
  &-list {
    display: flex;
    height: ptrd(54);
    align-items: center;
  }
  &-sale {
    height: ptrd(54);
    flex: 1;
    width: 1%;
  }
  &-btn {
    flex-shrink: 0;
    width: ptrd(94);
    height: ptrd(40);
    background-image: linear-gradient(270deg, #206cfe 2%, #4c88ff 100%);
    border-radius: ptrd(40);
    color: #fff;
    font-size: ptrd(24px);
    line-height: ptrd(40);
    text-align: center;
  }
  &-marquue {
    display: flex;
    align-items: center;
    height: ptrd(54);
    p {
      flex: 1;
      width: 1%;
      font-size: ptrd(24px);
      line-height: ptrd(28px);
      color: #fff;
      margin-left: ptrd(10px);
      @extend %ellipsis-basic;
    }
  }
  &-tag {
    display: block;
    width: ptrd(32px);
    height: ptrd(32px);
    flex-shrink: 0;
    margin-left: ptrd(6px);
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAGbElEQVRYR8WWe4yU1RnGf+e7zsyuopTevESIVwSlsRJJRAQvRREEVyTYFrqWqsSKMd4NC64kRIiJf0hiJaLrfXG9sK4gIngppVFAKJq2NmpD0UZ3aWwX7c7MN/PNd8x7zjezXHdX/MMvO7dvds7zvM/7vM85iu/5Ut8zPt+JgG5tWITmZrSK0UknjtOFpgvoQrEbrTvRThde0oXjdvHDut1qwuPFvYs+LAJaa8Wz05ehk99jatDpmul781GeFOj0O5W+V2qPIanU/WrWSyu+NQED/lTDQ6hkLloWtTg1HgIoYPteXaCGgHYtISV/m9Xs9jHfioABb7n8YUiusyB7/Vw+V4FrVbudaD1ZNbZv089ePYRSYSXoCw03pXap37QPHTABA7584nIq8bV4rgWTYhxHniwXR+6Z6uz3yr1BNbb/oSqGfqbhBEqVf6UtK6prOrIDImDAHzx3BbH+LcoBnYDr2oeR3LFE5HNVFccDV01Vc9Z01Ai8Oi+k89M8OnEMweCIQf0S0LrZ4YG1jxJFjSRJtX8W2PPBcSGpgBdYEiKI8sATAv7zau5rM2oEWqY0ktBSs4fnndonAQO+9JUWouJsKhULFFdspZ4DcaqE71MjF2ZSIi4EGfCD9fj+GhI9HMeZg9aeFUmB64w7JAEL3vEE+cKviWMr+/k3wOkXQXEP7OiA7S+CMkZIlZE2OAJqFQlCEELyXu4b96eQoqDjzjgoAd12lcsnnzxJVPglpTJUYpjSDGMbIcpDUobsINi4AjruTc0oi6cEpP+ZjFVACMirqCbfGw+Jb4xp5x1AIAV/mkJ+pqk8LoOXg0U7xNWweAzEJWjeAXEE84dbQiLEmF/B1Htg52ZYsxiibghDCLK9KtQyy0Av3oeAfmu8xzvdz5AvzDBVC7j0/NgRcOs66PoYlpxvF1z6T9v324eCjmHUZJj1sO3/xkdg3VJbee4Iq4KbGtaoUAvP3iQ04Ju6W4kK02uVi/FIIDcYmt6Bwh547HdwxiUwYS589j4suwJOGQdzWsALYetz0HYHBKkPcvUQ5iAMrIImN2qxvNoooJdf57N780qiYoOpuix9F/CqXljAcdemfVSQxPD0jVAqwDWPQJCDv2+A1lusMaXiTM4aMlNnVRMjytjaJJTnrcqCv9dGsWealfwg4FUiPz0NTh5rK/3wTeuFWQ9B9kjYuRVW3moNK4koaemGkK2z/Tev/l7hZVLzU6XvG91G/v9XmR9GkV3AAOoDNrl99pdBP4GZD0D9YPjiH/D8XVBOd1qpziShC2Ed1NXbYBJPiAK9cf210ktGT6GQf4FCPjCymsCRxOvjyh0NDYvgyB/Df/8NqxbYLKg/GvbshkpkWyWVmxbkehUwLTD7RAlXTbceuPdnlxH1vEgUheiUQHVH25+Hn4NJt8Pg4+Hr/8DqJXDqefDzBltdOYK/vgbbV4ErYSQk0mkIfLMj43vC8Ep107o1tTHUC8+4lGJ+FXEpNKlnHqkJq16UBSdcD0OGQvErWL/MGuyS26z8H22CE88BUejPj8Ouv9gRlDZIXMs0+GGEq65Q815fmwZyb4l64YiJRIV2SqWM9UDS2w6p7pyZ8KOTbABtfNQqcOalcPK58OFb8Lc34MQxcNY02LUNtr9sFZAJEPAgUyQIpqmbN6yroh6YhAtHXkwh/zJxKWsUMH5IYNRlIFNQKcOWNujutGvI/eNGwgdr4bMPYOQvYNjZdio++hM4Mo5ZyNUX8IOp6rY/ru/3TKibhl9EFHVQTkmIL0R+6XspD92f965xzOkwahL0/M9Ow7DRNgPebYX8l9XqCwT+5erudzfsb6lD74ZNIy4gyr9CuZQjSduxdzCZldLznWTD0LOs6+WW7AWigC/7QC6PH0xRC7a8ebC56vs80DRyPMWe1cSluhoJ8UU1yWqTouy4ZY+yIyiGlLAKsz0EwWS14L23DzXU/Z+I5g8fR1R8lXKprmZMA1w9dqdLm7mXGU/PA0GuBy+cpJq3buwrUvolYISeP2IsUb6duPwDY8zqiJpdLT0TVjcaaUOY/RIvmKaat23qO9H2OVf3/a+66cxhlHueJCqNtdtpOiHmHCiHDaxR/XATmdxstWDLzv7AD8iBgfxA33naRCrlq0GPR3OM2V61/hw/eBs/aFWL3q/N+EDWG1ALDrWQOa6bndUcDA/r+k4EDgtxvx99A92mgO7e42ZxAAAAAElFTkSuQmCC)
      no-repeat center center;
    background-size: 100%;
  }
}
</style>